import { X } from "lucide-react";
import { inr } from "@/lib/api";

const LBL = {
  requested: "Return Requested",
  approved: "Approved — pickup hoga",
  pickup_scheduled: "Pickup Scheduled",
  picked_up: "Picked Up",
  received: "Received at store",
  qc_done: "Quality Check",
  accepted: "Accepted",
  refund_initiated: "Refund Initiated",
  refund_completed: "Refund Completed",
  refunded: "Refund Completed",
  replacement_initiated: "Replacement Sent",
  replacement_completed: "Replacement Delivered",
  closed: "Return Closed",
  rejected: "Rejected",
};

export default function ReturnTrackModal({ ret, onClose }) {
  const tl = ret.timeline?.length ? ret.timeline : [{ status: ret.status, at: ret.created_at }];
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-end sm:items-center justify-center" data-testid="return-track-modal" onClick={onClose}>
      <div className="w-full sm:max-w-md bg-white rounded-t-3xl sm:rounded-3xl p-5 max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="mx-auto w-11 h-1.5 rounded-full bg-slate-200 mb-4 sm:hidden" />
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-xl font-extrabold">Return Tracking</h2>
            <p className="text-xs text-slate-500 mt-0.5">Order #{ret.order_no} · {inr(ret.refund_amount || 0)}{ret.resolution === "replacement" ? " · Replacement" : ""}</p>
          </div>
          <button data-testid="return-track-close" onClick={onClose} className="p-1 -mr-1 text-slate-400 hover:text-slate-700"><X size={22} /></button>
        </div>

        <div className="mt-5">
          {tl.map((t, i) => {
            const last = i === tl.length - 1;
            const rej = t.status === "rejected";
            const c = rej ? "#DC2626" : "#16A34A";
            return (
              <div key={i} className="flex gap-3">
                <div className="flex flex-col items-center">
                  <span className="w-3 h-3 rounded-full mt-1" style={{ backgroundColor: c }} />
                  {!last && <span className="w-0.5 flex-1 bg-slate-200 my-1" />}
                </div>
                <div className="pb-4">
                  <p className="text-sm font-bold" style={rej ? { color: "#DC2626" } : {}}>{LBL[t.status] || t.status}</p>
                  <p className="text-xs text-slate-400">{t.at ? new Date(t.at).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : ""}{t.note ? ` · ${t.note}` : ""}</p>
                </div>
              </div>
            );
          })}
        </div>

        <button data-testid="return-track-ok" onClick={onClose} className="mt-2 w-full h-12 rounded-xl bg-slate-900 text-white font-bold">OK</button>
      </div>
    </div>
  );
}
